module.exports = __webpack_public_path__ + "static/media/True_Anomaly.769977cd.png";